// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a220a901","455":"2f0c8b54","977":"d7ea4215"}[chunkId] + ".chunk.js";
};